import { LocaleService } from './../services/translate.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthServiceService } from '../services/auth-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SidenavService } from '../sidenav-bar/sidenav.service';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { PageService } from 'src/app/bloom/services/page-service.service';
import { environment } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { ThemeService } from '../services/theme.service';
import { isPlatformBrowser, Location, isPlatformServer } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { UIConfigService } from '../services/UIConfigService';
import { FormService } from 'src/app/form/form.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
    standalone: false
})
export class ToolbarComponent implements OnInit {
  languageList = {
    en: 'English',
    fr: 'Français'
    // ru: 'Pусский',
    // ja: '日本語'
  };
  recheckIfInMenu: boolean = false;
  menuStates = {
    products: false,
    resource: false,
    integrations: false,
    solutions: false
  };
  showToolbar: boolean;
  isBrowser: any;
  menuHoverTimeout: any;
  builderMode: boolean;
  isMenuItemHovered: boolean;

  get authService() { return this._authService; }
  @ViewChild('menuProduct' , {static: false}) menuTriggerMenuProducts: MatMenuTrigger;
  @ViewChild('menuIntegration') menuTriggerMenuIntegrations: MatMenuTrigger;
  @ViewChild('menuSolution') menuTriggerMenuSolutions: MatMenuTrigger;
  @ViewChild('menuResource') menuTriggerMenuResources: MatMenuTrigger;
  constructor(
    public _authService: AuthServiceService,
    public router: Router,
    public sidenavService: SidenavService,
    public connectionService: ConnectionService,
    public translate: TranslateService,
    public pageService: PageService,
    public formService: FormService,
    private themeService: ThemeService,
    private localeService: LocaleService,
    private location: Location,
    public uic: UIConfigService,
    @Inject(PLATFORM_ID) private platformId?: Object
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    }

    window:any;
  isGuestPage: boolean = false;

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      this.showToolbar = false;
      return;
    }
    this.window = window;
    let routeUrl = window?.location?.pathname || null;
    console.log("window routeUrl", routeUrl)
    if(!routeUrl) routeUrl = this.router.url;
    console.log("routeUrl", this.router.url)
    const containsSubstring = ['/client-platform', '/p/', '/redirect', 'connection/manage', '/oauth/authorize'].some(substring => routeUrl.includes(substring));
    if(!containsSubstring && !this.connectionService.isClientPlatform && !this.pageService.isSubdomainBloom){
      this.showToolbar = true;
    }


    // if(!this.isBrowser) {
    //   const containsSerSubstring = ['/viewer-canvas'].some(substring => routeUrl.includes(substring));
    //   if(containsSerSubstring) this.showToolbar = false;
    // }

    console.log("showToolbar", this.showToolbar)
    this.themeService.closeMenu$.subscribe((e) => {

      this.closePopup(e)
    })

  }

  trackByFn(index:number, item:any):any{
    return item || index
  }

  closePopup(e){
    if(!e || e == "product"){
      this.menuTriggerMenuProducts?.closeMenu()
    } else if (e == "resource"){
      this.menuTriggerMenuResources?.closeMenu()
    }

  }

  isMenuOpen(menu: string): boolean {
    return this.menuStates[menu];
  }

  isAnyMenuOpen(): boolean {
    return Object.values(this.menuStates).some(state => state === true);
  }

  resetAllMenu(e = null){
    // Reset all menu states first
    Object.keys(this.menuStates).forEach(key => {
      if (!e || key !== e) {
        this.menuStates[key] = false;
      }
    });

  }

  closeAllMenu(){
    // Close all menus first
    this.menuTriggerMenuProducts?.closeMenu();
    this.menuTriggerMenuIntegrations?.closeMenu();
    this.menuTriggerMenuSolutions?.closeMenu();
    this.menuTriggerMenuResources?.closeMenu();
  }

  onMenuHover(e) {
    this.resetAllMenu(e)
    // Set the current menu state to true
    this.menuStates[e] = true;
    this.closeAllMenu();

    // Open only the requested menu
    switch(e) {
      case 'products':
        this.menuTriggerMenuProducts?.openMenu();
        break;
      case 'resource':
        this.menuTriggerMenuResources?.openMenu();
        break;
      case 'integrations':
        this.menuTriggerMenuIntegrations?.openMenu();
        break;
      case 'solutions':
        this.menuTriggerMenuSolutions?.openMenu();
        break;
    }
  }


  onMenuHoverLeave(e, event?: any) {
    this.isMenuItemHovered = false;

    if (this.builderMode) {
      // For builder mode, we need to be more careful about closing the menu
      // Only close if we're sure the mouse isn't over the menu
      setTimeout(() => {
        // Check if mouse is on the menu before closing
        if (!this.recheckIfInMenu && !this.isMenuItemHovered) {
          this.closeMenu(e);
          this.menuStates[e] = false;
        }
      }, 200);
    } else {
      setTimeout(() => {
        if (!this.recheckIfInMenu && !this.isAnyMenuOpen()) {
          this.closeMenu(e);
          this.menuStates[e] = false;
        }
      }, 1000);
    }
  }

  onMenuEnter() {
    this.recheckIfInMenu = true;
  }

  onMenuLeave(e) {
    this.recheckIfInMenu = false;
    this.menuStates[e] = false;
    this.onMenuHoverLeave(e);
  }

  private closeMenu(menu: string) {
    switch (menu) {
      case 'products':
        this.menuTriggerMenuProducts?.closeMenu();
        break;
      case 'resource':
        this.menuTriggerMenuResources?.closeMenu();
        break;
      case 'integrations':
        this.menuTriggerMenuIntegrations?.closeMenu();
        break;
      case 'solutions':
        this.menuTriggerMenuSolutions?.closeMenu();
        break;
    }
  }

  toggleLeftSideNav() {
    if (this.sidenavService.mobileQuery.matches) {
      this.sidenavService.toggle('left');
    } else {
      this.sidenavService.setSidenavWithModes();
    }
  }

  onMenuItemHover(){
    this.isMenuItemHovered = true;
  }

  onMenuHoverWithDelay(menu: string) {
    this.cancelMenuOpenDelay(); // Clear any existing timeout before setting a new one

    // Reset all menu states first
    Object.keys(this.menuStates).forEach(key => {
      if (key !== menu) {
        this.menuStates[key] = false;
      }
    });

    // setTimeout(() => {
      this.builderMode = this.pageService.builderMode || this.formService.builderMode
      if (!this.builderMode) {
        // If builder mode is false, open instantly
        this.onMenuHover(menu);
        // this.recheckIfInMenu = true;
      } else {
        // If builder mode is true, apply the delay
        this.menuHoverTimeout = setTimeout(() => {
          this.onMenuHover(menu);
          this.recheckIfInMenu = true;
        }, 300); // Adjust delay as needed
      }
    // }, 0)
  }

  cancelMenuOpenDelay() {

    setTimeout(() => {
      if (!this.isMenuItemHovered && this.builderMode) {
        this.recheckIfInMenu = false;
      }
    }, 100);

    if (this.menuHoverTimeout) {
      clearTimeout(this.menuHoverTimeout);
      this.menuHoverTimeout = null;
    }
  }

  navigateToArticles(){
    window.open(`${environment.BASE_URL}/p/${environment.INTERNAL_BLOOM.ARTICLE}/articles`, "_blank")
  }

  navigateToIntegrations(){
    window.open(`${environment.BASE_URL}/p/${environment.INTERNAL_BLOOM.INTEGRATIONS}/all-apps`, "_blank")
  }

  switchLang(lang: string) {
    this.localeService.changeLocale(lang)
  }

  navigateToSignUp(){
    this.router.navigate(['sign-up'], {queryParams: this.authService.navigateParams});
  }
  navigateToLogin(){
    if(!this.authService.loggedIn) this.router.navigate([''], {queryParams: this.authService.navigateParams});
  }
}
